/** Marchio e dominio pubblici — logo e sito sono «6amico» / 6amico.com */
export const SITE_BRAND = "6amico";
export const SITE_DOMAIN = "6amico.com";

/** URL pubblico del sito (VPS o locale). Emergent non è più usato. */
export const SITE_ORIGIN =
  (process.env.REACT_APP_PUBLIC_SITE_URL || "").replace(/\/$/, "") ||
  (typeof window !== "undefined" ? window.location.origin : "http://164.92.161.151");

export const ADMIN_URL = `${SITE_ORIGIN}/admin`;
export const PIAZZE_URL = `${SITE_ORIGIN}/piazze`;
export const HOST_URL = `${SITE_ORIGIN}/host`;
